import {
  Avatar,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import { useContext } from "react";
import { IconContext } from "react-icons";
import { BiFolder, BiTrash } from "react-icons/bi";
import { base64ToFile } from "utils/_firmaElectronica";
import { FirmaElectronicaContext } from "../context/firmaElectronicaContext";
import { CertificadoInterface } from "../interfaces/firmaInterfaces";

interface CertificadoPropsInterface {
  certificado: CertificadoInterface;
  handleDeleteCertificado: (certificado: CertificadoInterface) => void;
}

export const Certificado = ({
  certificado,
  handleDeleteCertificado,
}: CertificadoPropsInterface) => {
  const {
    addCerFile,
    addKeyFile,
    handleClickShowCerKeySave,
    readCertificate,
    readPrivateKey,
  } = useContext(FirmaElectronicaContext);

  const handleSelectCertificado = (certificado: CertificadoInterface) => {
    const cerFile = base64ToFile(
      certificado.cert.certBase64,
      certificado.cert.name
    );
    const keyFile = base64ToFile(
      certificado.key.keyBase64,
      certificado.key.name
    );
    addCerFile(cerFile);
    addKeyFile(keyFile);
    readCertificate(cerFile);
    readPrivateKey(keyFile);
    handleClickShowCerKeySave(false);
  };
  return (
    <ListItem
      secondaryAction={
        <IconButton
          edge="end"
          aria-label="delete"
          onClick={() => handleDeleteCertificado(certificado)}
        >
          <IconContext.Provider value={{ className: "2xl" }}>
            <BiTrash />
          </IconContext.Provider>
        </IconButton>
      }
    >
      <ListItemAvatar
        className="cursor-pointer"
        onClick={() => handleSelectCertificado(certificado)}
      >
        <Avatar>
          <BiFolder />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        className="cursor-pointer truncate"
        primary={certificado.cert?.name}
        onClick={() => handleSelectCertificado(certificado)}
      />
    </ListItem>
  );
};
